import {
  StaticSidebarComponent,
  StaticSidebarComponentOptions,
} from '@/lib/types';

import { SpecialtyPage } from '@/features/specialty-page';

export default function filterSidebarComponent(
  specialtyPage: SpecialtyPage,
  component: StaticSidebarComponentOptions
): StaticSidebarComponent[] {
  if (!specialtyPage.sidebar?.specialtyPageSidebarComponents) return [];

  return specialtyPage.sidebar?.specialtyPageSidebarComponents.filter(
    (c) =>
      c.__typename === 'StaticSidebarComponent' &&
      c.staticSidebarComponent === component
  ) as StaticSidebarComponent[];
}
